import { render } from "./mvt-cardschool.vue?vue&type=template&id=6771b8e0"
import script from "./mvt-cardschool.js?vue&type=script&lang=js"
export * from "./mvt-cardschool.js?vue&type=script&lang=js"

import "./mvt-cardschool.vue?vue&type=style&index=0&id=6771b8e0&lang=scss"

import exportComponent from "/builds/movoto/frontend/consumer-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__